<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title text-left">Lista de Usuários</h4>
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select
                  class="select-success mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                >
                  <el-option
                    class="select-success"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>
              <div
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <div>
                  <base-input>
                    <el-input
                      type="search"
                      class="mb-3 search-input"
                      color="success"
                      clearable
                      prefix-icon="el-icon-search"
                      placeholder="Pesquisar usuário"
                      v-model="searchQuery"
                      aria-controls="datatables"
                    >
                    </el-input>
                  </base-input>
                </div>
                <div>
                  <base-button
                    type="success"
                    class="animation-on-hover"
                    style="margin: 0px 5px 0px 5px;"
                    @click="mostrarDialog('Cadastrar')"
                    >Cadastrar Usuário</base-button
                  >
                </div>
              </div>
            </div>
            <el-table :data="queriedData">
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              >
              </el-table-column>
              <el-table-column :min-width="135" align="right" label="Ações">
                <div slot-scope="props">
                  <el-tooltip
                    content="Editar"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click="mostrarDialog('Alterar', props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-pencil"></i>
                    </base-button>
                  </el-tooltip>

                  <el-tooltip
                    content="Editar Senha"
                    effect="light"
                    :open-delay="300"
                    placement="top"
                  >
                    <base-button
                      @click="mostrarDialog('Alterar Senha', props.row)"
                      class="edit btn-link"
                      type="info"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-key-25"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="font-weight-normal">
                Mostrando de {{ from + 1 }} a {{ to }} no total de
                {{ total }} Usuários.
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="dialogCadUsuario">
      <template slot="header">
        <h4 class="modal-title" id="exampleModalLabel">
          {{ tipo }}
        </h4>
      </template>
      <div class="row">
        <!--Campo Funcionario-->
        <div
          class="col-md-12 text-left form-group has-label row"
          v-if="tipo == 'Cadastrar'"
        >
          <label>
            Funcionário
          </label>
          <autocomplete
            class="col-12"
            :search="carregarFuncionario"
            placeholder="Selecionar Funcionário"
            aria-label="Selecionar Funcionário"
            :get-result-value="procurarFuncionario"
            @submit="selecionarFuncionario"
          >
          </autocomplete>
        </div>

        <div class="col-md-12 text-left form-group has-label row" v-else>
          <label>
            {{ funcionarioSelecionado.nome }}
          </label>
        </div>

        <!--Campo Perfil-->
        <div class="col-md-12 text-left" v-if="tipo != 'Alterar Senha'">
          <base-input label="Perfil">
            <el-select
              class="select-success pagination-select"
              placeholder="Selecione uma opção"
              v-model="payloadCadUsuario.idPerfil"
            >
              <el-option
                v-for="item in perfis"
                :key="item.id"
                class="select-success"
                :label="item.descricao"
                :value="item.id"
                >{{ item.descricao }}</el-option
              >
            </el-select>
          </base-input>
        </div>

        <div class="col-12" v-if="tipo != 'Alterar Senha'">
          <label for="postoTrabalho" class="form-label  text-left w-100">
            Empresas Autorizadas
          </label>
          <el-select
            multiple
            class="select-success pagination-select w-100"
            size="large"
            collapse-tags
            v-model="payloadCadUsuario.restrincaoEmpresa"
            placeholder="Selecione as opções"
          >
            <el-option
              v-for="option in restrincaoEmpresas"
              class="select-info"
              :value="option.idEmpresa"
              :label="option.local"
              :key="option.idEmpresa"
            >
            </el-option>
          </el-select>
        </div>

        <!--Campo Senha-->
        <div
          class="col-md-12 text-left"
          v-if="tipo == 'Cadastrar' || tipo == 'Alterar Senha'"
        >
          <base-input
            label="Senha"
            placeholder="Senha"
            v-model="payloadCadUsuario.senha"
            type="password"
            :class="erros.senha === true ? 'has-danger' : ''"
          >
          </base-input>
        </div>

        <!--Campo Confirmar Senha-->
        <div
          class="col-md-12 text-left"
          v-if="tipo == 'Cadastrar' || tipo == 'Alterar Senha'"
        >
          <base-input
            label="Confirmar Senha"
            placeholder="Confirmar Senha"
            v-model="payloadCadUsuario.csenha"
            type="password"
            :class="erros.csenha === true ? 'has-danger' : ''"
          >
          </base-input>
        </div>
      </div>
      <template slot="footer">
        <div class="w-100 d-flex justify-content-end">
          <base-button type="success" @click="selecionarFuncao()"
            >Salvar</base-button
          >
        </div>
      </template>
    </modal>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { Card, BasePagination, BaseInput } from "@/components/index";
import { Table, TableColumn, Select, Option } from "element-ui";
import swal from "sweetalert2";
import Fuse from "fuse.js";
import Modal from "@/components/Modal.vue";

export default {
  components: {
    Card,
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseInput,
    Modal,
  },
  computed: {
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      dadosUsuario: "",
      payloadCadUsuario: {
        senha: "",
        csenha: "",
        idPerfil: 1,
        idFuncionario: 0,
        restrincaoEmpresa: [],
      },
      restrincaoEmpresas: [],
      perfis: [],
      funcionarios: [],
      funcionarioSelecionado: "",
      tipo: "",
      descricao: "",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10],
        total: 0,
      },
      isLoading: false,
      dialogCadUsuario: false,
      searchQuery: "",
      propsToSearch: ["nome", "cpf"],
      tableColumns: [
        {
          prop: "id",
          label: "Id",
          minWidth: 25,
        },
        {
          prop: "nome",
          label: "Nome",
          minWidth: 300,
        },
        {
          prop: "cpf",
          label: "CPF",
          minWidth: 300,
        },
      ],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      fuseFunSearch: null,
      erros: {
        senha: "",
        csenha: "",
      },
    };
  },
  mounted() {
    this.carregarDadosUsuario();
    this.listarUsuarios();
    this.listarFuncionarios();
    this.listarPerfis();
    this.listarPostos();
  },
  methods: {
    carregarDadosUsuario() {
      this.dadosUsuario = this.$cookies.get("usuario") || null;
    },
    selecionarFuncao() {
      switch (this.tipo) {
        case "Alterar":
          this.editarUsuario();
          break;
        case "Alterar Senha":
          this.editarSenhaUsuario();
          break;
        case "Cadastrar":
          this.cadastrarUsuario();
          break;
      }
    },
    selecionarFuncionario(result) {
      if (result) {
        this.funcionarioSelecionado = result;
        this.payloadCadUsuario.idFuncionario = result.id;
        return result.nome;
      } else return "";
    },
    procurarFuncionario(result) {
      if (result) return result.nome;
      else return "";
    },
    carregarFuncionario(input) {
      if (input.length > 1) return this.fuseFunSearch.search(input);
      else {
        this.funcionarioSelecionado = "";
        this.payloadCadUsuario.idFuncionario = 0;
        return this.funcionarios;
      }
    },

    inicializarFuseFun() {
      this.fuseFunSearch = new Fuse(this.funcionarios, {
        keys: ["nome", "cpf"],
        threshold: 0.3,
      });
    },
    inicializarFuse() {
      this.fuseSearch = new Fuse(this.tableData, {
        keys: ["nome", "cpf"],
        threshold: 0.3,
      });
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },

    listarUsuarios() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        idUsuario: "",
      };

      if (this.dadosUsuario) {
        bodyFormData.idUsuario = this.dadosUsuario.id;
      }

      this.axios
        .post("/api/usuarios/listarUsuario", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          if (response.data.data.length > 0) {
            th.tableData = response.data.data;
          } else {
            th.tableData = [];
          }
          th.inicializarFuse();
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao listar!", "error");
        });
    },

    listarFuncionarios() {
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        idUsuario: "",
      };

      if (this.dadosUsuario) {
        bodyFormData.idUsuario = this.dadosUsuario.id;
      }

      this.axios
        .post("/api/empregado/listarEmpregados2", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          // th.block.funcionario = false;
          th.funcionarios = response.data.data.dados;

          th.inicializarFuseFun();
        })
        .catch((err) => {
          // th.block.funcionario = false;
        });
    },

    listarPostos() {
      const th = this;
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
      };

      this.axios
        .post("/api/empregador/listarTodosEmpregadores2", bodyFormData)
        .then((response) => {
          if (response.data.data.dados.length > 0) {
            th.restrincaoEmpresas = response.data.data.dados.map((e) => {
              return {
                local: e.local,
                idEmpresa: e.id,
                status: false,
              };
            });
          }
        })
        .catch((err) => {
          th.restrincaoEmpresas = [];
          console.log(err);
        });
    },

    listarPerfis() {
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/usuarios/listarPerfil", bodyFormData)
        .then((response) => {
          // th.block.funcionario = false;
          th.perfis = response.data.data;
        })
        .catch((err) => {
          // th.block.funcionario = false;
        });
    },

    cadastrarUsuario() {
      if (this.validarCampos()) {
        let th = this;
        this.isLoading = true;

        let bodyFormData = {
          setDB: this.$cookies.get("db"),
          senha: this.payloadCadUsuario.senha,
          confirmaSenha: this.payloadCadUsuario.senha,
          idPerfil: this.payloadCadUsuario.idPerfil,
          idFuncionario: this.payloadCadUsuario.idFuncionario,
          restricaoEmpresa: this.restrincaoEmpresas
            .filter((e) =>
              this.payloadCadUsuario.restrincaoEmpresa.includes(e.idEmpresa),
            )
            .map((fe) => {
              fe.status = "true";
              return fe;
            }),
        };

        this.axios
          .post("/api/usuarios/criarUsuario", bodyFormData, {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          })
          .then((response) => {
            th.isLoading = false;
            th.dialogCadUsuario = false;
            th.listarUsuarios();
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Cadastrado realizado com sucesso!",
              "success",
            );
          })
          .catch((err) => {
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao cadastrar usuário!",
              "error",
            );
          });
      } else {
        this.showSwal(
          "auto-close",
          "Erro",
          "Preencha os campos obrigatórios",
          "error",
        );
      }
    },

    async mostrarDialog(tipo, row) {
      //limpando possivel lixo
      this.dialogCadUsuario = true;
      this.tipo = tipo;
      this.funcionarioSelecionado = "";
      this.erros.csenha = "";
      this.erros.senha = "";
      this.payloadCadUsuario.restrincaoEmpresa = [];
      this.payloadCadUsuario.idPerfil = 1;
      this.payloadCadUsuario.senha = "";
      this.payloadCadUsuario.csenha = "";

      if (row) {
        this.funcionarioSelecionado = row;
        this.payloadCadUsuario.restrincaoEmpresa = this.funcionarioSelecionado.restricaoEmpresa
          .filter((fr) => fr.status == "true")
          .map((f) => f.idEmpresa);
        this.payloadCadUsuario.idPerfil = this.funcionarioSelecionado.idPerfil;
      }
    },

    async excluirDialog(row) {
      this.funcionarioSelecionado = row;

      swal({
        title: "Tem certeza?",
        text: `Deseja realmente excluir o perfil?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Não!",
        buttonsStyling: false,
      })
        .then((response) => {
          if (response.value) {
            this.excluirPerfil();
          }
        })
        .catch((err) => {});
    },

    excluirPerfil() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: this.funcionarioSelecionado.id,
      };

      this.axios
        .post("/api/usuarios/deletarPerfil", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.dialogCadUsuario = false;
          th.listarUsuarios();
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Excluído com sucesso!",
            "success",
          );
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal("auto-close", "Erro", "Erro ao excluir perfil!", "error");
        });
    },

    editarUsuario() {
      let th = this;
      this.isLoading = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        id: this.funcionarioSelecionado.id,
        idPerfil: this.payloadCadUsuario.idPerfil,
        restricaoEmpresa: this.restrincaoEmpresas
          .filter((re) =>
            this.payloadCadUsuario.restrincaoEmpresa.includes(re.idEmpresa),
          )
          .map((r) => {
            return {
              idUsuario: this.funcionarioSelecionado.id,
              idEmpresa: r.idEmpresa,
              status: "true",
            };
          }),
      };

      this.axios
        .post("/api/usuarios/editarUsuarioPerfil", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.isLoading = false;
          th.dialogCadUsuario = false;
          th.listarUsuarios();
          th.showSwal(
            "auto-close",
            "Sucesso",
            "Atualizado com sucesso!",
            "success",
          );
        })
        .catch((err) => {
          th.isLoading = false;
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao atualizar perfil!",
            "error",
          );
        });
    },

    editarSenhaUsuario() {
      const validarSenha = () => {
        let status = true;

        if (
          this.payloadCadUsuario.senha == "" ||
          this.payloadCadUsuario.csenha == ""
        ) {
          this.erros.senha = true;
          this.erros.csenha = true;
          status = false;
        }
        if (this.payloadCadUsuario.senha !== this.payloadCadUsuario.csenha) {
          this.erros.senha = true;
          this.erros.csenha = true;
          status = false;
        }
        if (
          this.payloadCadUsuario.length <= 5 ||
          this.payloadCadUsuario.csenha.length <= 5
        ) {
          this.erros.senha = true;
          this.erros.csenha = true;
          status = false;
        }

        return status;
      };

      if (validarSenha()) {
        let th = this;
        this.isLoading = true;

        let bodyFormData = {
          setDB: this.$cookies.get("db"),
          id: this.funcionarioSelecionado.id,
          senha: this.payloadCadUsuario.senha,
          confirmaSenha: this.payloadCadUsuario.csenha,
        };

        this.axios
          .post("/api/usuarios/editarUsuarioSenha", bodyFormData, {
            headers: {
              "id-actor": this.$cookies.get("id_actor"),
              "tipo-actor": this.$cookies.get("tipo_actor"),
            },
          })
          .then((response) => {
            th.isLoading = false;
            th.dialogCadUsuario = false;
            th.listarUsuarios();
            th.showSwal(
              "auto-close",
              "Sucesso",
              "Atualizado com sucesso!",
              "success",
            );
          })
          .catch((err) => {
            th.isLoading = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao atualizar senha!",
              "error",
            );
          });
      }
    },

    validarCampos() {
      let status = true;

      if (
        this.payloadCadUsuario.senha == "" ||
        this.payloadCadUsuario.csenha == ""
      ) {
        this.erros.senha = true;
        this.erros.csenha = true;
        status = false;
      }
      if (this.payloadCadUsuario.senha !== this.payloadCadUsuario.csenha) {
        this.erros.senha = true;
        this.erros.csenha = true;
        status = false;
      }
      if (
        this.payloadCadUsuario.length <= 5 ||
        this.payloadCadUsuario.csenha.length <= 5
      ) {
        this.erros.senha = true;
        this.erros.csenha = true;
        status = false;
      }
      if (!this.payloadCadUsuario.idPerfil) {
        status = false;
      }
      if (!this.payloadCadUsuario.idFuncionario) {
        status = false;
      }

      return status;
    },
  },
  watch: {
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style>
.divCorpoDialog {
  padding: 0px;
  margin-top: -25px;
}
</style>
